module.exports = __webpack_public_path__ + "img/logo15.0900aef1.png";